export const LOGOUT = "LOGOUT";
export const SET_CONTEXT = "SET_CONTEXT";
export const SET_MATTER = "SET_MATTER";
export const SET_ACTION ="SET_ACTION";
export const CLEAR_CASE_SUMMARY_DATA = "CLEAR_CASE_SUMMARY_DATA";